@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.image {
  max-height: 100%;
  max-width: 100%;
  box-shadow: 1px 1px 2px 1px @scan-page--item-list-image--box-shadow-color;
}

.item-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 115px;
  padding: 0 20px;
  margin: 7px 0;
}

.placeholder {
  background-color: @scan-page--item-list-image--background-color;
  text-align: center;
  width: 75px;

  svg {
    fill: @scan-page--item-list-image--icon-color;
    height: 75px;
  }
}
